// Dashboard Users onboarding page translations (en-US), loaded into dashboard.users.onboarding by ../en-US.users.js
module.exports = {
  menu: "Onboarding funnel",
  title: "Onboarding Funnel",
  description: "Where the platform is losing users, step by step.",
  kpis: {
    installs: "Installs",
    conversion: "Total conversion",
    worstDrop: "Biggest drop",
    timeToFirstEvent: "Time to the 1st event",
  },
  info: {
    installs: "Times the app was opened for the first time after being installed; they cannot be linked to the accounts, so they stay out of the funnel.\nSource: Google Analytics (first_open event).",
    conversion: "Accounts created in the period that reached the last step of the funnel (came back the next day).\nSource: Firebase (profiles, events and activity log).",
    worstDrop: "Step of the funnel where the most accounts are lost, in percentage points vs. the previous step.\nSource: Firebase (the same funnel counts).",
    timeToFirstEvent: "Median days between the account creation and the first event created.\nSource: Firebase (first event of each creator).",
  },
  units: {
    days: "days",
  },
  hints: {
    noInstalls: "no Google Analytics data",
    conversion: "{from} → {to}",
    median: "median",
  },
  base: {
    accounts: "accounts created",
    installs: "installs",
  },
  steps: {
    created: "Created an account",
    confirmed: "Confirmed the sign-up",
    photo: "Added a photo",
    bio: "Wrote a bio",
    joined: "Joined an event",
    createdEvent: "Created an event",
    returned: "Came back the next day",
  },
  panels: {
    funnel: {
      title: "Onboarding funnel — {base} in the period",
      note: "Each step counts the accounts created in the period that did it, even without doing the previous one. \"Came back the next day\" only counts the accounts created up to {date}: the ones of the last day of the period, or of today, have no next day yet.",
      noteNoReturn: "Each step counts the accounts created in the period that did it, even without doing the previous one. \"Came back the next day\" has no data yet: the accounts created in the period have no next day yet.",
    },
    conversion: "Total conversion by {gran}",
    conversionNote: "When fewer than {min} accounts are created in a {gran}, the conversion adds the previous ones until it reaches that number.",
    loss: "Loss per step (percentage points)",
  },
  panelInfo: {
    funnel: "Accounts created in the period that did each step.\nSource: Firebase (profiles, accounts, events and activity log).",
    conversion: "Accounts created that reached the last step, in each interval.\nSource: Firebase (profiles, accounts, events and activity log).",
    loss: "Percentage points lost from each step to the next one.\nSource: Firebase (profiles, accounts, events and activity log).",
  },
};
